module.exports = __webpack_public_path__ + "img/xinxianggaoxinquAppImage.cfb73b4e.png";